import store from '@/store/store'
import { RawLocation, Route } from 'vue-router'
import Vue from 'vue'
import SharedStorage from '@/utils/SharedStorage'
import Swal from 'sweetalert2'
import RouteName from '@/utils/RouteName'
import { jwtTokenName, refreshJwtTokenName } from '@/utils/auth'
import JwtDecode from 'jwt-decode'
import { safeFrenchFoundersRedirect } from '@/utils/safeRedirect.ts'
import { Spa2Route } from '@/ExternalRoutes'

export default async function(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
) {
    const token = window.currentJwt || SharedStorage.get(jwtTokenName) || null
    const jwtDecoded = token ? JwtDecode(token) : ''
    const refreshToken = window.currentJwtRefresh || SharedStorage.get(refreshJwtTokenName) || null

    const routeNamesMatched = to.matched.map(match => match.name)

    if (to.name === RouteName.LOGOUT) {
        return next()
    }

    const isClubLost = jwtDecoded
        ? store.getters['user/hasRole']('ROLE_BL_LECLUB_LOST', jwtDecoded) ||
          store.getters['user/hasRole']('ROLE_BL_LECLUB_EXPERT_LOST', jwtDecoded) ||
          store.getters['user/hasRole']('ROLE_BL_LECLUB_PARTNER_LOST', jwtDecoded)
        : false

    // @ts-ignore
    if (!store.state.user.token && token) {
        await store.dispatch('user/setToken', { token, refreshToken })
    }

    if (store.getters['user/isConnected']) {
        // @ts-ignore
        if (!store.state.user.me) {
            await store.dispatch('user/getMe')
        } else {
            store.commit('user/SET_ME_COMPLETED')
        }

        const redirectionPathForPartners = Spa2Route.INBOX()

        // cas spécial pour les losts
        if (to.name !== RouteName.LOGOUT && isClubLost && to.meta.allowLost) {
            return next(false)
        }

        if (
            to.name !== RouteName.LOGOUT &&
            !store.getters['user/hasRole']('ROLE_BL_LECLUB') &&
            !store.getters['user/hasRole']('ROLE_BL_LECLUB_EXPERT') &&
            !store.getters['user/hasRole']('ROLE_BL_LECLUB_PARTNER') &&
            store.getters['user/hasRole']('ROLE_BL_LECLUB_PARTNER_CONTACT') &&
            !to.meta.allowContactPartner &&
            to.path !== redirectionPathForPartners
        ) {
            console.warn(`Route ${to.name} is not allowed for partners !!`)
            Swal.fire({
                title: 'Accès impossible',
                text: `Vous n'êtes pas autorisé à accéder à cette page.`,
                icon: 'error',
            })

            // Délai pour permettre l'affichage de l'alerte (temporaire, tant qu'on redirige pas vers une page de la SPA)
            setTimeout(() => {
                window.location.href = redirectionPathForPartners
            }, 1000)
            return next(false)
        }

        if (store.getters['user/isLead'] && !to.meta.allowLead) {
            console.warn(`Route ${to.name} is not allowed for leads !!`)
            // Comment the redirection if you need the logs in dev
            return next({
                name: RouteName.LOGIN,
                query: {
                    redirectUrl: to.fullPath,
                },
            })
        }

        // Routes autorisées pour les utilisateur network qui vont sur la partie Club et qui ne démarre pas par /public/*
        if (
            (routeNamesMatched.includes(RouteName.MEMBERSHIP) && isClubLost) ||
            to.path.startsWith('/update-account') ||
            to.path.startsWith('/event/payment') ||
            to.path.startsWith('/spa/app/login-and-redirect') ||
            to.name === RouteName.EVENT_LIVE ||
            to.name === RouteName.EVENT_BACKSTAGE ||
            to.name === RouteName.EVENT_LIVE_SCHEDULE ||
            to.name === RouteName.EVENT_LIVE_STAGE ||
            to.name === RouteName.EVENT_LIVE_NETWORKING ||
            to.name === 'event-live-partners'
        ) {
            return next()
        } else if (!to.path.startsWith('/public') && !store.getters['user/hasRole']('ROLE_BL_LECLUB')) {
            if (process.env.VUE_APP_SPA2_BASE_URL) {
                //window.location.href = process.env.VUE_APP_SPA2_BASE_URL
                safeFrenchFoundersRedirect(
                    (to.query.redirectUrl as string) ||
                        (to.query.redirect as string) ||
                        (window.loginTargetUrl as string) ||
                        process.env.VUE_APP_SPA2_BASE_URL
                )
            }
            return next(false)
        }
    } else if (to.meta.anonymousForbidden) {
        console.warn(`Route ${to.name} is not allowed for anonymous !!`)
        // Comment the redirection if you need the logs in dev
        return next({
            name: RouteName.LOGIN,
            query: {
                redirectUrl: to.fullPath,
            },
        })
    }

    return next()
}
